import "./Splitter.css";
import Text from "../Text/Text.jsx";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";

const Splitter = ({ image, children, hasButton, buttonText, nav, reverse }) => {
  return (
    <div className={`event-section ${reverse ? "reverse" : ""}`}>
      <div className="event-image">
        <img src={image} alt="" />
      </div>
      <div className="event-text">
        {children}
        {hasButton && (
          <div className="event-buttons">
            <Button
              component="a"
              href={nav}
              variant="contained"
              sx={{
                backgroundColor: "var(--primary-color)",
                color: "#fff",
                padding: "10px 20px",
                borderRadius: "5px",
                fontWeight: 500,
                textAlign: "center",
                fontSize: "16px",
                border: "none",
                boxShadow: "none",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "var(--primary-color-hover)",
                  border: "none",
                  boxShadow: "none",
                  color: "#fff",
                },
              }}
            >
              {buttonText || "Mehr erfahren"}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Splitter;
